import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import { Button, Card } from "react-bootstrap";

function EnvironmentPage() {
    return (<>
        <Navbar />
        <Card>
            <Card.Header>Umwelt</Card.Header>
            <Card.Body>
                <Card.Text>
                    Der Tauchsport ist ein aktiver Natursport und bietet eine großartige Möglichkeit, sich mit der Natur und ihren ökologischen Zusammenhängen auseinanderzusetzen. Während der Ausübung, Vorbereitung und Nachbereitung unseres Sports sind wir direkt in der Natur und erleben deren Auswirkungen hautnah.
                    <br /><br />
                    Dies bietet hervorragende pädagogische Ansätze, um ein Bewusstsein für Umweltfolgen zu schaffen. Durch das Eintauchen in die Unterwasserwelt entdecken wir eine faszinierende Welt mit vielfältiger Flora und Fauna, die es zu schützen gilt.
                    <br /><br />
                    Unser Verein organisiert einmal im Jahr das traditionelle "Umweltwochenende", bei dem nicht das Tauchen, sondern das Erleben und der Schutz der Umwelt im Mittelpunkt stehen. Dies ist eine wertvolle Erfahrung, besonders für unsere Kinder- und Jugendgruppe.
                </Card.Text>
            </Card.Body>
        </Card>
        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>);
}

export default EnvironmentPage;
